import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Badge from 'react-bootstrap/Badge';

import InsightImagePreview from "./InsightImagePreview";
import { PROMPT_TAGS } from "./promptTags";

const PromptEditModal = ({ prompt, editedText, onChangeText, onSave, onClose, saving }) => {
    const isDirty = prompt && editedText !== prompt.prompt;
    const tags = PROMPT_TAGS[prompt?.type] ?? [];

    return (
        <Modal show={!!prompt} onHide={onClose} size="xl" scrollable>
            <Modal.Header closeButton>
                <Modal.Title className="font-monospace">{prompt?.type}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {tags.length > 0 && (
                    <div className="mb-2">
                        <small className="text-muted d-block mb-1">Available tags — replaced at runtime:</small>
                        <div className="d-flex flex-wrap gap-1">
                            {tags.map(tag => (
                                <Badge key={tag} bg="secondary" className="font-monospace fw-normal">{tag}</Badge>
                            ))}
                        </div>
                    </div>
                )}
                <Form.Control
                    as="textarea"
                    rows={24}
                    value={editedText}
                    onChange={e => onChangeText(e.target.value)}
                    style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}
                />
                {prompt?.type === 'InsightImage' && <InsightImagePreview promptText={editedText} />}
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
                <small className="text-muted">
                    Last updated: {prompt ? new Date(prompt.updated_at).toLocaleString() : ''}
                </small>
                <div className="d-flex gap-2">
                    <Button variant="outline-secondary" onClick={onClose} disabled={saving}>Cancel</Button>
                    <Button variant="primary" onClick={onSave} disabled={!isDirty || saving}>
                        {saving ? <><Spinner size="sm" animation="border" className="me-2" />Saving…</> : 'Save'}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default PromptEditModal;
